module.exports = __webpack_public_path__ + "images/694d5bec99e45cb53a0f3d721a2c76a1.svg";